import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormsModule, FormControl } from '@angular/forms';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { SearchModalComponent } from '../search-modal/search-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { MemberSignupModalComponent } from '../../sub-admin/member-signup-modal/member-signup-modal.component';
import { NgxSpinnerService } from "ngx-spinner";
import moment from 'moment';


@Component({
  selector: 'app-subadmin-header',
  templateUrl: './subadmin-header.component.html',
  styleUrls: ['./subadmin-header.component.scss']
})
export class SubadminHeaderComponent implements OnInit {
  callLog: FormGroup

  subAdminData: any;
  remarkData: any;
  phone: string;
  subAdminId: any;
  callLogData: any;
  adminId: any;
  allRight = [];
  custRnk: any;
  totalAmnt: number = 0;
  feedbackQty = 2;
  noFeedback: any = 0;
  quantity = 1;
  callsClosing: any = 0;
  repairBy: any = 0;
  showBonusLoader = 0;
  previousMonthsArray: { num: number; month: string; }[];
  selectedBonusMonth = moment().month() + 1;
  showLoader = 0;
  profitValue = 0;
  lossValue = 0;
  inventory_quantity = 0.5;

  announcement1 = '';
  announcement2 = '';
  announcement3 = '';
  announcement_listing: any;
  a1 = '';
  a2 = '';
  a3 = '';
  newCustRank: any;
  userType: any;
  invoiceInitial: any;

  setAnn1(event) {
    this.announcement1 = event.target.value;
  }

  setAnn2(event) {
    this.announcement2 = event.target.value;
  }

  setAnn3(event) {
    this.announcement3 = event.target.value;
  }

  constructor(
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService) {

      this.callLog = this.fb.group({})

      }
  name: any;
  imgUrl: any;
  isSearchOn = 0;
  private modalRef;
  callLogDataLength = 0;
  submitted = false;

  ngOnInit(): void {
    this.getProfileDetail();
    this.getAdminData()
    this.generateCallLog()
    this.isSearchOn = 1;

    let { id } = this.local.getUser();
    let {userType} = this.local.getUser();
    this.adminId = id;
    this.userType = userType;

    this.previousMonths();
    
    if(this.userType != 'guest') {
      this.get_announcements();
      this.getCallLogData()
      this.half_half_profit(moment().month() + 1);
      // this.getMonthsYearsData('admin', [], [], id);

    }
    
  }

  get callLogsValidator() { return this.callLog.controls; }

  logout() {
    this.toastr.success('Logged out successfully');
    this.local.logout();
    this.local.removeAdminData();

    if(this.userType != 'guest') {
      this.router.navigate(['/admin'])

    } else {
      this.router.navigate(['/admin/guest-login'])

    }
  }

  half_half_profit(month) {
    let formData = new FormData();

    formData.append('month', month);

    this.auth.half_half_profit(formData).subscribe((response: any) => {
      this.profitValue = response.body.profit;
      this.lossValue = response.body.loss;
      // alert(this.profitValue)

      this.local.setProfitLossValues(this.profitValue, this.lossValue);

    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }

  getMonthsYearsData(type, arrY: any[], arrM: any[], adminId: any, showLoader = 0) {

    if(showLoader == 1) {
      this.showBonusLoader = 1;
    }

    switch (type) {

      case 'admin': {
        this.spinner.show();
        const formdata = new FormData();
        formdata.append('adminId', adminId);
        if (arrY.length != 0) {
          formdata.append('year', arrY.toString());
        }
        if (arrM.length != 0) {
          formdata.append('month', arrM.toString());
        }

        this.auth.get_prof_data_admin_filter(formdata).subscribe((response: any) => {
          // console.log("---",response.body);
          this.allRight = response.body;
          this.spinner.hide();
          // this.adminCode = response.body.adminCode;
          // this.getAllFeedback(adminId);
          this.makeRightSideReponse(this.allRight, showLoader);
          // this.getAllgraphsData(adminId)
          // if(this.selectedAdmin == undefined){
          // this.makeLeftSideResponse(this.allRight);
          // }

          // console.log(this.allRight,"-------------------------allright");

        }, (error) => {
          if (error.error.status == 401) {
            this.local.logout();
            this.spinner.hide();
            this.router.navigate(['/admin'])
          }
        })
        break;
      }
    }

  }

  makeRightSideReponse(arr: any = [], showLoader) {
    this.noFeedback = arr.right.numberOfFeedback.count;
    this.callsClosing = arr.right.callsClosing.count;
    this.repairBy = arr.right.reapirsBy.count;
    this.custRnk = arr.finalRank;
    this.newCustRank = arr.newFinalRank;
    this.invoiceInitial = arr.right.invoice.count;
    this.totalAmnt = (this.feedbackQty * parseFloat(this.noFeedback)) + (this.quantity * parseFloat(this.callsClosing)) + (this.quantity * parseFloat(this.repairBy) + (this.inventory_quantity * parseFloat(this.invoiceInitial)));
    // this.totalAmnt = this.totalAmnt;

    // console.log(this.totalAmnt,'====================================================totalAmt')
    // console.log(this.custRnk,'======================================================custRank')

    if(showLoader == 1) {
      this.showBonusLoader = 0;
    }


  }

  getProfileDetail() {
    this.auth.getProfile().subscribe((response: any) => {
      this.name = response.body.userName;
      this.imgUrl = `https://dev.vvip.com.sg:3011/${response.body.image}`;
      // console.log("yes",this.imgUrl)
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    })
  }

  generateCallLog(){
    this.callLog = this.fb.group({
      phone:["",Validators.required],
      subAdminId:['',Validators.required],
      remark1:[''],
      remark2:[''],
      price:[''],
    })
   
  }

  showSearchModal() {
    this.modalService.open(SearchModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
  }

  showMemberSignup() {
    this.modalService.open(MemberSignupModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
  }

  getAdminData() {
    this.auth.suadmindata().subscribe((response: any) => {
      let hiddenAdmins = [1, 36, 37, 39, 40, 41, 42, 28, 60, 61, 55, 62, 63, 68, 64];
      this.subAdminData = response.body.filter(e => !hiddenAdmins.includes(e.id));

      // console.log(this.subAdminData,'===========================subAdminData')
    });

    this.auth.getRemark().subscribe((response: any) => {
      this.remarkData = response.body
    });
  }

  open_call_logs_modal(modal) {
    this.modalRef = this.modalService.open(modal, { size: 'lg', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
  }

  public submitdata(){
    try {
      this.submitted = true;

      if(this.callLog.invalid) {
        return false;
      }

      // console.log(this.callLog.value,'====================================data')
      // return

      let formData = new FormData();
      formData.append('phone', this.callLog.value.phone);
      formData.append('subAdminId', this.callLog.value.subAdminId);
      formData.append('remark1', (this.callLog.value.remark1 == null)?0:this.callLog.value.remark1);
      formData.append('remark2', (this.callLog.value.remark2 == null)?0:this.callLog.value.remark2);
      formData.append('price', (this.callLog.value.price == null)?'':this.callLog.value.price);

      this.auth.addCallLogData(formData).subscribe((response: any) => {
        // this.remarkData = response.body

        // console.log(response,'============================response')

        this.toastr.success(response.message);
        this.modalService.dismissAll();

        this.getCallLogData()
     
        this.submitted = false;

      }, (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        } else if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      });

    } catch (e) {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      } else if (e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin']);
      }
    }

  }

  getCallLogData(){
    try {
      this.auth.getcallLogdata().subscribe((response: any) => {
        this.callLogData = response.body
        this.callLogDataLength = response.body.length;

        this.callLog.reset();
      });
    } catch (e) {
      // console.log(e)
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      } else if (e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin']);
      }
    }
  }

  onImgError(event) {
    event.target.src = '../../../assets/images/default.png';
  }

  previousMonths() {
    let monthsArray = [{
      num: 1,
      month: 'Jan'
    }, {
      num: 2,
      month: 'Feb'
    }, {
      num: 3,
      month: 'Mar'
    }, {
      num: 4,
      month: 'Apr'
    }, {
      num: 5,
      month: 'May'
    },{
      num: 6,
      month: 'Jun'
    },{
      num: 7,
      month: 'Jul'
    },{
      num: 8,
      month: 'Aug'
    },{
      num: 9,
      month: 'Sep'
    },{
      num: 10,
      month: 'Oct'
    },{
      num: 11,
      month: 'Nov'
    },{
      num: 12,
      month: 'Dec'
    }];

    let currentMonth = moment().month() + 1;

    let monthIndex = monthsArray.findIndex(x => x.num == currentMonth);
    monthsArray[monthIndex].month = 'Current';

    let slicedMonthArray = monthsArray.slice(0, monthIndex + 1);

    this.previousMonthsArray = slicedMonthArray;
    this.selectedBonusMonth = currentMonth;

  }
  
  get_bonus_points(event) {

    // console.log(event.target.value,'====================================selected month')

    this.getMonthsYearsData('admin', [], [event.target.value], this.adminId, 1);
    this.half_half_profit(event.target.value);
  }

  open_announcement_modal(modal) {
    this.modalRef = this.modalService.open(modal, { size: 'md', ariaLabelledBy: 'modal-basic-title',backdrop:'static'});

  }

  get_announcements() {
    this.auth.announcement_listing().subscribe((response: any) => {

      this.announcement_listing = response.body;

      this.announcement1 = this.announcement_listing.find(x => x.type == 1).title;
      this.announcement2 = this.announcement_listing.find(x => x.type == 2).title;
      this.announcement3 = this.announcement_listing.find(x => x.type == 3).title;

      this.a1 = this.announcement_listing.find(x => x.type == 1).title;
      this.a2 = this.announcement_listing.find(x => x.type == 2).title;
      this.a3 = this.announcement_listing.find(x => x.type == 3).title;


    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      } else if (e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin']);
      }
    });
  }

  save_announcements() {

    let formData = new FormData();
    formData.append('announcement1', this.announcement1);
    formData.append('announcement2', this.announcement2);
    formData.append('announcement3', this.announcement3);

    this.auth.save_announcements(formData).subscribe((response: any) => {

      this.modalService.dismissAll();
      this.toastr.success(response.message);

      // this.announcement1 = response.body.a1;
      // this.announcement2 = response.body.a2;
      // this.announcement3 = response.body.a3;

      this.get_announcements();

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      } else if (e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin']);
      }
    });
    
  }

}
